module.exports = __webpack_public_path__ + "static/media/start-screen-logo@3x.d848b431.png";